import { render, staticRenderFns } from "./WidgetList.html?vue&type=template&id=34e3a4fb&scoped=true&external"
import script from "./WidgetList.ts?vue&type=script&lang=ts&external"
export * from "./WidgetList.ts?vue&type=script&lang=ts&external"
import style0 from "./WidgetList.css?vue&type=style&index=0&id=34e3a4fb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e3a4fb",
  null
  
)

export default component.exports